
export const roadDataHelper = {
    methods: {
        getRoadDataTableContent(data) {
            let results = []
            // Road address
            results.push({title: this.$t('map.street_address'), value: data.road_number + ' / ' + data.section_number + ' / ' + data.distance + ' m'})
            results.push({title: this.$t('roaddata.road_class'), value: this.getRoadClassText(data.road_class)})
            results.push({title: this.$t('roaddata.government_area'), value: data.government_area})

            // Speed limits
            let speedLimit = data.speedlimit_1
            if (data.speedlimit_2) {
                speedLimit += ' / ' + data.speedlimit_2
            }
            if (data.winter_speed_limit) {
                speedLimit += ' (' + data.winter_speed_limit + ') km/h'
            }
            results.push({title: this.$t('roaddata.speedlimit'), value: speedLimit})

            // Restrictions and warnings
            results.push({title: this.$t('roaddata.warning_area'), value: this.getWarningText(data.warning_animal)})
            results.push({title: this.$t('roaddata.salt_restriction'), value: data.salt_restriction === true ? this.$t('common.yes') : this.$t('common.no')})

            // Ground water area
            results.push({title: this.$t('roaddata.ground_water_class'), value: this.getGroundWaterClassText(data.groundwater_class)})
            results.push({title: this.$t('roaddata.ground_water_type'), value: this.getGroundWaterTypeText(data.groundwater_type)})

            // Maintenance contract
            results.push({title: this.$t('roaddata.contract_number'), value: data.contract_number})
            results.push({title: this.$t('roaddata.contract_name'), value: data.contract_name})

            // Maintenance classes
            results.push({title: this.$t('roaddata.winter_maintenance_class'), value: data.maintenance_class})
            results.push({title: this.$t('roaddata.green_maintenance_class'), value: data.green_maintenance_class})
            results.push({title: this.$t('roaddata.pavement_maintenance_class'), value: data.pavement_maintenance_class})
            results.push({title: this.$t('roaddata.gravel_road_maintenance_class'), value: data.gravel_road_class})

            // Paving data
            results.push({title: this.$t('roaddata.lane_width'), value: data.lane_width})
            results.push({title: this.$t('roaddata.pavement_year'), value: data.pavement_year ? data.pavement_year.slice(0, 4) : '-'})
            results.push({title: this.$t('roaddata.pavement_type'), value: this.getPavementTypeText(data.pavement_type)})
            results.push({title: this.$t('roaddata.pavement_method'), value: data.surface_method})
            results.push({title: this.$t('roaddata.pavement_thickness'), value: data.pavement_thickness ?  data.pavement_thickness : '-'})
            results.push({title: this.$t('roaddata.pavement_width'), value: data.pavement_width ?  data.pavement_width : '-'})

            // Traffic amount data
            results.push({title: this.$t('roaddata.daily_traffic'), value: data.daily_traffic_amount})
            results.push({title: this.$t('roaddata.daily_heavy_traffic'), value: data.daily_heavy_traffic_amount})


            // Lighting data
            results.push({title: this.$t('roaddata.lighting_owner'), value: this.getLightingOwnerText(data.lighting_owner)})
            results.push({title: this.$t('roaddata.lighting_type'), value: this.getLightingTypeText(data.lighting_type)})
            results.push({title: this.$t('roaddata.lamp_type'), value: data.lamp_type ? data.lamp_type : '-'})

            return results
        },

        getGroundWaterClassText(value) {
            if (!value){
                return ''
            }
            switch (value) {
                case 1: return this.$t('roaddata.ground_water_class_important')
                case 2: return this.$t('roaddata.ground_water_class_applicable')
                case 3: return this.$t('common.other')
                case 6: return this.$t('roaddata.ground_water_class_1')
                case 7: return this.$t('roaddata.ground_water_class_2')
                case 8: return this.$t('roaddata.ground_water_class_E')
                case 9: return this.$t('roaddata.ground_water_class_1E')
                case 10: return this.$t('roaddata.ground_water_class_2E')
                case 90: return this.$t('roaddata.ground_water_class_no_area')
            }
            return this.$t('common.unknown')
        },

        getGroundWaterTypeText(value) {
            if (!value){
                return ''
            }
            switch (value) {
                case 1: return this.$t('roaddata.ground_water_form')
                case 2: return this.$t('roaddata.ground_water_area')
            }
            return this.$t('common.unknown')
        },



        getWarningText(value) {
            if (!value){
                return '-'
            }
            switch (value) {
                case 1: return this.$t('roaddata.warning_moose')
                case 2: return this.$t('roaddata.warning_deere')
                case 3: return this.$t('roaddata.warning_reindeer')
            }
            return this.$t('common.unknown')
        },


        getRoadClassText(value) {
            switch (value) {
                case 1: return this.$t('roaddata.highway')
                case 2: return this.$t('roaddata.road')
                case 3: return this.$t('roaddata.regional_road')
                case 4: return this.$t('roaddata.connecting_road')
            }
            return this.$t('common.unknown')
        },

        getPavementTypeText(value) {
            switch (value) {
                case 1: return this.$t('roaddata.pavement_asphalt')
                case 2: return this.$t('roaddata.pavement_asphalt_concrete')
                case 3: return this.$t('roaddata.pavement_hard_asphalt')
                case 4: return this.$t('roaddata.pavement_soft_asphalt')
                case 5: return this.$t('roaddata.pavement_bearing_asphalt')
                case 6: return this.$t('roaddata.pavement_binding_asphalt')
                case 7: return this.$t('roaddata.pavement_concrete')
                case 8: return this.$t('roaddata.pavement_discontinuous_asphalt')
                case 9: return this.$t('roaddata.pavement_soft_b')
                case 10: return this.$t('roaddata.pavement_soft_epab')
                case 11: return this.$t('roaddata.pavement_soft_pabo')
                case 12: return this.$t('roaddata.pavement_soft_pabv')
                case 13: return this.$t('roaddata.pavement_soft_epabv')
                case 14: return this.$t('roaddata.pavement_mastix')
                case 15: return this.$t('roaddata.pavement_mastic_asphalt')
                case 16: return this.$t('roaddata.pavement_asphalt_concrete_eab')
                case 17: return this.$t('roaddata.pavement_asphalt_concrete_compact')
                case 18: return this.$t('roaddata.pavement_composite_asphalt')
                case 19: return this.$t('roaddata.pavement_bearing_asphalt_concrete')
                case 20: return this.$t('roaddata.pavement_binding_asphalt_concrete')
            }
            return this.$t('common.unknown')
        },

        getLightingOwnerText(value) {
            switch (value) {
                case 1: return this.$t('roaddata.owner_government')
                case 2: return this.$t('roaddata.owner_municipality')
                case 3: return this.$t('roaddata.owner_other')
            }
            return this.$t('common.unknown')
        },

        getLightingTypeText(value) {
            switch (value) {
                case 1: return this.$t('roaddata.lighting_road')
                case 2: return this.$t('roaddata.lighting_bicycle_road')
                case 3: return this.$t('roaddata.lighting_spot')
                case 4: return this.$t('roaddata.lighting_tunnel_bridge')
                case 5: return this.$t('roaddata.lighting_other')
            }
            return this.$t('common.unknown')
        },
    }
}
